<template>
    <div
        class="blur-[75px] w-[100px] h-[300px] absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2 -rotate-90 rounded-full overflow-hidden z-[1]"
        :class="pricingCardBgColor"
    ></div>
</template>

<script setup lang="ts">
type SelectedPlanNames = "standard" | "pro" | "pro-plus" | "enterprise";

interface IProps {
    planName: SelectedPlanNames;
}
const props = defineProps<IProps>();

const pricingCardBgColor = computed((): string => {
    const bgColorList: Record<SelectedPlanNames, string> = {
        standard: "bg-[#DBA34F] opacity-30",
        pro: "bg-[#FF85B1] opacity-30",
        "pro-plus": "bg-[#6E24F0] opacity-60",
        enterprise: "bg-gray-100 opacity-30",
    };
    return bgColorList[props.planName] || "";
});
</script>
<style scoped>
.card-blur {
    -webkit-filter: blur(75px);
    filter: blur(75px);
}
</style>
